class VisitDiscountController {
  /* @ngInject */
  constructor($log, $interval, Endpoints, Discounts, Promos, Services, MedicationPrice, toastr) {
    Object.assign(this, {
      $log,
      $interval,
      Endpoints,
      Discounts,
      Promos,
      Services,
      MedicationPrice,
      toastr,
      adding: false,
      editing: false
    });
    this.getCategories();
    this.getPromos();
    this.getVisitDiscounts();
  }

  changeCategory() {
    // We refresh list of Products and Medications according to the Service
    this.getProductsByCategory();
    this.getMedicationsByCategory();
  }

  changeProduct() {
    // We clear Medication selected
    this.selectedMedication = this.medications[0];
  }

  changeMedication() {
    // We clear Product selected
    this.selectedProduct = this.products[0];
  }

  getCategories() {
    this.Services.list().then(({
      data
    }) => {
      var categories = [];
      data.data.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
      data.data.forEach(category => {
        if (category.children && category.children.length) {
          category.children.forEach(child => {
            child.code_name = child.code + ' - ' + child.name;
            categories.push(child);
          });
        } else {
          category.code_name = category.code + ' - ' + category.name;
          categories.push(category);
        }
      });
      categories.unshift({
        code_name: "Please select a service"
      });
      this.categories = categories;
      this.selectedCategory = this.categories[0];
    }).catch(err => {
      this.categories = [];
      this.toastr.error('Error getting services: ' + JSON.stringify(err));
    });
  }

  getProductsByCategory() {
    this.Services.getProductListByCategory(this.selectedCategory.code).then(({
      data
    }) => {
      data.sort(function (a, b) {
        if (a.code < b.code) {
          return -1;
        }

        if (a.code > b.code) {
          return 1;
        }

        return 0;
      });
      data.forEach(product => {
        product.id_code_title = product.id + ' - ' + product.code + ' - ' + product.title;
      });
      data.unshift({
        id_code_title: "Please select a product"
      });
      this.products = data;
      this.selectedProduct = this.products[0];
    }).catch(err => {
      this.products = [];
      this.toastr.error('Error getting products by service: ' + JSON.stringify(err));
    });
  }

  getMedicationsByCategory() {
    this.Services.getMedicationListByCategory(this.selectedCategory.code).then(({
      data
    }) => {
      data.sort(function (a, b) {
        if (a.medication_name < b.medication_name) {
          return -1;
        }

        if (a.medication_name > b.medication_name) {
          return 1;
        }

        return 0;
      });
      data.forEach(medication => {
        medication.id_name = medication.medication_id + ' - ' + medication.medication_name;
      });
      data.unshift({
        id_name: "Please select a medication"
      });
      this.medications = data;
      this.selectedMedication = this.medications[0];
    }).catch(err => {
      this.medications = [];
      this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
    });
  }

  getPromos() {
    this.Promos.all({
      limit: 1000
    }).then(({
      data
    }) => {
      data.data.forEach(promo => {
        promo.id_name_type_discount = promo.id + ' - ' + promo.name + ' - ' + promo.type + ' - ' + promo.discount.type + ' ' + promo.discount.value;
      });
      data.data.unshift({
        id_name_type_discount: "Please select a promo"
      });
      this.promos = data.data;
      this.selectedPromo = this.promos[0];
    }).catch(err => {
      this.promos = [];

      if (err && err.status && err.status == 403) {
        this.toastr.error("Error: Access denied to get promo codes list.");
      } else {
        this.toastr.error("Error getting promo codes list: " + JSON.stringify(err));
      }
    });
  }

  getVisitDiscounts() {
    this.Discounts.listVisitDiscount().then(({
      data
    }) => {
      this.results = data;
    }).catch(err => {
      this.results = [];
      this.toastr.error('Error getting visit discounts: ' + JSON.stringify(err));
    });
  }

  edit(row) {
    this.editing = true;
    this.category_promos_xref_id = row.category_promos_xref_id;
    this.category = row.category_code + ' - ' + row.category_name;

    if (row.product_id) {
      this.product = row.product_id + ' - ' + row.product_code;
    } else {
      this.product = null;
    }

    if (row.medication_id) {
      this.medication = row.medication_id + ' - ' + row.medication_code;
    } else {
      this.medication = null;
    }

    this.selectedPromo = this.promos.find(x => x.id === row.promo_id);
    this.visit_number = row.visit_number;
    this.active = row.active;
  }

  add() {
    this.adding = true;
    this.visit_number = 0;
    this.active = 1;
  }

  cancelAddVisitDiscount() {
    this.adding = false;
  }

  cancelEditVisitDiscount() {
    this.editing = false;
  }

  updateVisitDiscount() {
    var this2 = this;

    if (this.selectedPromo.id_name_type_discount == 'Please select a promo') {
      this.toastr.warning('Please select a promo');
      return;
    }

    if (this.visit_number == null || isNaN(this.visit_number)) {
      this.toastr.warning('Please enter the visit number');
      return;
    }

    var payload = {
      promo_id: this.selectedPromo.id,
      visit_number: this.visit_number,
      active: this.active
    };
    this.Discounts.updateVisitDiscount(this.category_promos_xref_id, payload).then(() => {
      this.toastr.success('Visit discount updated successfully');
      this2.filteredResults.forEach(discount => {
        if (discount.category_promos_xref_id == this2.category_promos_xref_id) {
          discount.promo_id = this2.selectedPromo.id;
          discount.promo_name = this2.selectedPromo.name;
          discount.promo_type = this2.selectedPromo.type;
          discount.promo_discount_type = this2.selectedPromo.discount.type;
          discount.promo_discount_value = this2.selectedPromo.discount.value;
          discount.visit_number = this2.visit_number;
          discount.active = this2.active;
        }
      });
      this.editing = false;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Error updating visit discount: ' + JSON.stringify(err));
    });
  }

  addVisitDiscount() {
    if (this.selectedCategory.code_name == 'Please select a service') {
      this.toastr.warning('Please select a service');
      return;
    }

    if ((!this.selectedProduct || this.selectedProduct.id_code_title == 'Please select a product') && (!this.selectedMedication || this.selectedMedication.id_name == 'Please select a medication')) {
      this.toastr.warning('Please select a product or medication');
      return;
    }

    if (this.selectedPromo.id_name_type_discount == 'Please select a promo') {
      this.toastr.warning('Please select a promo');
      return;
    }

    if (this.visit_number == null || isNaN(this.visit_number)) {
      this.toastr.warning('Please enter the visit number');
      return;
    }

    var payload = {
      promo_id: this.selectedPromo.id,
      visit_number: this.visit_number,
      active: this.active
    };

    if (this.selectedProduct && this.selectedProduct.id) {
      this.Discounts.addVisitDiscountByCategoryAndProduct(this.selectedCategory.id, this.selectedProduct.id, payload).then(() => {
        this.toastr.success('Visit discount added successfully');
        this.getVisitDiscounts();
      }).catch(err => {
        console.log(err);
        this.toastr.error('Error adding visit discount: ' + JSON.stringify(err));
      });
    } else if (this.selectedMedication && this.selectedMedication.medication_id) {
      this.Discounts.addVisitDiscountByCategoryAndMedication(this.selectedCategory.id, this.selectedMedication.medication_id, payload).then(() => {
        this.toastr.success('Visit discount added successfully');
        this.getVisitDiscounts();
      }).catch(err => {
        console.log(err);
        this.toastr.error('Error adding visit discount: ' + JSON.stringify(err));
      });
    }
  }

}

VisitDiscountController.$inject = ["$log", "$interval", "Endpoints", "Discounts", "Promos", "Services", "MedicationPrice", "toastr"];
angular.module('pims').controller('VisitDiscountController', VisitDiscountController);